// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"73370481","667":"aa91ecb2","977":"138a6d1e"}[chunkId] + ".chunk.js";
};